import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=013ba002&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=013ba002&prod&scoped=true&lang=css&external"
import style1 from "./statistics.vue?vue&type=style&index=1&id=013ba002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ba002",
  null
  
)

export default component.exports